import React from "react";
import * as styles from "./Cases.module.scss";
import { casesShared } from "@shared/arrays/dashly-vs";

export function Cases() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <header className={styles.head}>
          <h2 className={styles.heading}>{casesShared.title}</h2>
          <p className={styles.lead}>{casesShared.lead}</p>
        </header>

        <ul className={styles.grid}>
          {casesShared.items.map((item) => (
            <li key={item.href} className={styles.card}>
              <p className={styles.metric}>
                <span className={styles.value}>{item.metric}</span>
                <span className={styles.unit}>{item.unit}</span>
              </p>
              <p className={styles.text}>{item.text}</p>
              <a className={styles.link} href={item.href}>
                {casesShared.linkLabel}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Cases;
